<template>
  <section :class="embedded ? 'py-0' : 'bg-[#fcf5ec] py-12'">
    <div :class="embedded ? 'p-0  mx-auto' : 'bg-[#EEDCC5] p-6 lg:p-12  mx-auto'">
      <h2 class="text-[38px] font-black italic uppercase text-[#111] mb-2">{{ t('productManage.dashboard.menu.myDetails') }}</h2>
      <p class="text-[15px] text-[#333] mb-8">{{ t('productManage.dashboard.profileDesc') }}</p>

      <div v-if="loaded && user" class="space-y-8">
        <!-- Flash messages bovenaan -->
        <MmFlashMessage
          v-if="message"
          :message="message"
          type="success"
          :autoHideMs="6000"
          @dismiss="message = ''"
          class="mb-6"
        />
        <MmFlashMessage
          v-if="error"
          :message="error"
          type="error"
          @dismiss="error = ''"
          class="mb-6"
        />

        <!-- Identiteit -->
        <div class="bg-[#F6EBDC] p-5">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-10 h-10 bg-black text-white grid place-items-center font-extrabold">1</div>
            <h3 class="text-[20px] font-black italic uppercase">{{ t('productManage.dashboard.menu.myAccount') }}</h3>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-[1060px]">
            <input v-model="firstName" type="text" :placeholder="t('placeholders.firstName') + ' *'"
                   class="h-12 px-3 border bg-white" :class="firstName? 'border-[#d8d1c6]' : 'border-[#d8d1c6]'" />
            <input v-model="lastName" type="text" :placeholder="t('placeholders.lastName') + ' *'"
                   class="h-12 px-3 border bg-white" :class="lastName? 'border-[#d8d1c6]' : 'border-[#d8d1c6]'" />

            <div>
              <input v-model="email" type="email" :placeholder="t('placeholders.email') + ' *'"
                     class="h-12 px-3 border bg-white w-full" :class="(!isValidEmail(email) ? 'border-[#b91c1c]' : 'border-[#d8d1c6]')" />
              <p v-if="!isValidEmail(email)" class="mt-1 text-[13px] text-[#b91c1c]">{{ t('messages.emailInvalid') }}</p>
            </div>
            <div>
              <input v-model="email2" type="email" :placeholder="t('placeholders.emailConfirm') + ' *'"
                     class="h-12 px-3 border bg-white w-full" :class="(!isValidEmail(email2) || (email && email2 && email!==email2) ? 'border-[#b91c1c]' : 'border-[#d8d1c6]')" />
              <p v-if="!isValidEmail(email2)" class="mt-1 text-[13px] text-[#b91c1c]">{{ t('messages.emailInvalid') }}</p>
              <p v-else-if="email && email2 && email!==email2" class="mt-1 text-[13px] text-[#b91c1c]">{{ t('messages.emailsNoMatch') }}</p>
            </div>

            <div class="lg:col-span-2 text-[14px] text-[#555]">
              <strong>{{ t('regionUsers.labels.role') }}:</strong>
              <span class="inline-flex items-center gap-2 px-2 py-1 bg-white border border-[#d8d1c6]">
                <!-- Zelfde iconen als in registratie -->
                <template v-if="(user.roleType||'').toLowerCase()==='bedrijf'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 49.733 46.985" aria-hidden="true">
                    <g transform="translate(0)">
                      <path d="M149.9,25.236a18.1,18.1,0,0,0,36.047-3.263" transform="translate(-142.724 3.563)" fill="#fff"/>
                      <path d="M168.485,44.016a19.827,19.827,0,0,1-19.7-18.033,1.722,1.722,0,1,1,3.429-.31,16.377,16.377,0,0,0,32.619-2.953,1.721,1.721,0,0,1,3.428-.311,19.842,19.842,0,0,1-17.951,21.524q-.913.082-1.821.082" transform="translate(-143.317 2.969)"/>
                      <path d="M176,7.635h0a19.081,19.081,0,0,1,10.935,15.59l-38.073,3.446a19.1,19.1,0,0,1,7.957-17.305" transform="translate(-143.314 -3.981)" fill="#e24c3b"/>
                      <path d="M149.449,28.982a1.721,1.721,0,0,1-1.714-1.566,20.939,20.939,0,0,1,8.672-18.857,1.721,1.721,0,1,1,2,2.8,17.5,17.5,0,0,0-7.312,14.022l34.475-3.121a17.47,17.47,0,0,0-9.711-12.478,1.721,1.721,0,0,1,1.459-3.116,20.916,20.916,0,0,1,11.925,16.994,1.722,1.722,0,0,1-1.56,1.868L149.6,28.975c-.053,0-.1.006-.156.006" transform="translate(-143.906 -4.568)"/>
                      <path d="M192.6,20.606a3.112,3.112,0,0,1-2.8,3.358l-40.085,3.629a3.134,3.134,0,0,1-3.194-4.231,3,3,0,0,1,2.613-1.937l.012,0L189.233,17.8a3.11,3.11,0,0,1,3.371,2.813" transform="translate(-144.6 1.358)" fill="#e24c3b"/>
                      <path d="M150.027,29.919a4.818,4.818,0,0,1-.44-9.616l40.085-3.628a4.819,4.819,0,1,1,.882,9.6L150.469,29.9a4.313,4.313,0,0,1-.443.02M190.109,20.1a.892.892,0,0,0-.127.006L149.9,23.73a1.365,1.365,0,0,0-1.241,1.482v.006a1.386,1.386,0,0,0,1.5,1.253l40.086-3.629a1.291,1.291,0,0,0,.91-.476,1.307,1.307,0,0,0,.331-1.012,1.388,1.388,0,0,0-1.375-1.259" transform="translate(-145.198 0.765)"/>
                      <path d="M154.8,18.266l-.73-8.064v0a2.3,2.3,0,0,1,2.082-2.5l3.144-.285,4.144-.375,4.174-.377,3.287-.3a2.142,2.142,0,0,1,2.326,1.938l.014.157.73,8.064" transform="translate(-140.537 -4.652)" fill="#e24c3b"/>
                      <path d="M155.388,20.579a1.721,1.721,0,0,1-1.711-1.566l-.745-8.228a.707.707,0,0,0-.006-.113,4.03,4.03,0,0,1,3.661-4.093l14.6-1.323a4.026,4.026,0,0,1,4.324,3.371c.006.038.011.076.014.119l.745,8.22a1.721,1.721,0,0,1-3.428.311l-.74-8.147a.571.571,0,0,0-.606-.443L156.9,10.01a.583.583,0,0,0-.53.546L157.1,18.7a1.721,1.721,0,0,1-1.558,1.87c-.053,0-.105.008-.157.008" transform="translate(-141.132 -5.241)"/>
                      <path d="M164.566,34.006a7.751,7.751,0,0,1-6.709-3.884,1.721,1.721,0,0,1,2.975-1.731,4.3,4.3,0,0,0,3.738,2.169h.382a4.291,4.291,0,0,0,3.626-2.8,1.721,1.721,0,0,1,3.234,1.177,7.752,7.752,0,0,1-6.6,5.056h-.035c-.2.015-.409.023-.612.023" transform="translate(-138.66 6.024)"/>
                    </g>
                  </svg>
                  <span>{{ t('roles.company') }}</span>
                </template>
                <template v-else-if="(user.roleType||'').toLowerCase()==='school'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 51.643 46.331" aria-hidden="true">
                    <g transform="translate(0)">
                      <path d="M194.806,70.116a19.877,19.877,0,1,1-23.263-15.779A19.877,19.877,0,0,1,194.806,70.116Z" transform="translate(-146.112 -49.127)" fill="#fff"/>
                      <path d="M175.879,96.068a21.628,21.628,0,1,1,4.073-.389,21.624,21.624,0,0,1-4.073.389m.014-39.76A18.153,18.153,0,1,0,193.718,71.05a18.157,18.157,0,0,0-17.826-14.741" transform="translate(-146.721 -49.737)"/>
                      <path d="M187.934,54.578s11.089-2.681,12.759,9.569c.7,5.161-.043,9.221-1.72,11.466a1.93,1.93,0,0,1-2.567.485,25.487,25.487,0,0,1-7.1-6.936s-2.5,7.051-8.809,8.957a1.517,1.517,0,0,1-1.879-1.038c-.011-.041-.021-.082-.031-.124-.337-1.648-1.155-4.156-3.065-5.053,0,0-4.788,8.6-14.689,9.946-4.5.612-7.263-2.405-9.307-4.25a1.1,1.1,0,0,1-.088-1.555,1.084,1.084,0,0,1,.446-.3c2.175-.777,4.96-1.917,5.191-5.758,0,0-5.909,1.43-7.71-4.336-.153-.49.078-1.012.589-.971,1.516.127,3.744,1.912,6.688-.781,3.017-1.789,10.563-11.915,18.264-12.96a17.456,17.456,0,0,1,13.026,3.641" transform="translate(-149.316 -50.799)" fill="#f7941e"/>
                      <path d="M172.335,61.965s-5.064,9.093-15.538,10.52c-2.663.253-3.982-.382-6.247-1.807a1.1,1.1,0,0,0,.34,1.048c2.045,1.845,4.8,4.864,9.308,4.25,9.9-1.349,14.689-9.946,14.689-9.946a3.375,3.375,0,0,1,.436.267,6.566,6.566,0,0,0-2.99-4.334" transform="translate(-148.679 -44.925)"/>
                      <path d="M189.85,56.964c.614,5.183-.177,9.264-1.888,11.552a2.043,2.043,0,0,1-2.717.514,26.96,26.96,0,0,1-7.512-7.335s-2.643,7.455-9.322,9.471a1.486,1.486,0,0,1-.441.06,11.7,11.7,0,0,1,.8,2.488,1.518,1.518,0,0,0,1.786,1.19,1.217,1.217,0,0,0,.124-.031c6.306-1.908,8.809-8.957,8.809-8.957a25.481,25.481,0,0,0,7.1,6.936,1.932,1.932,0,0,0,2.575-.482c1.676-2.245,2.422-6.3,1.719-11.466a15.475,15.475,0,0,0-1.032-3.934" transform="translate(-139.5 -47.556)"/>
                      <path d="M171.563,79.69a8.346,8.346,0,0,1-7.274-4.278,1.721,1.721,0,0,1,3.008-1.67,4.879,4.879,0,0,0,4.582,2.5h.029a4.889,4.889,0,0,0,4.2-3.136,1.721,1.721,0,0,1,3.22,1.216A8.341,8.341,0,0,1,172.2,79.67h-.041c-.2.014-.4.021-.6.021" transform="translate(-141.543 -39.648)"/>
                    </g>
                  </svg>
                  <span>{{ t('roles.school') }}</span>
                </template>
                <template v-else-if="(user.isCoordinator) || ((user.roleType||'').toLowerCase()==='coordinator')">
                  <span>{{ t('productManage.dashboard.menu.regionManagement') }}</span>
                </template>
                <template v-else>
                  <span>{{ user.roleType || 'Onbekend' }}</span>
                </template>
              </span>
              <span class="ml-2 text-[#7a7366]">(niet wijzigbaar)</span>
            </div>

            <div v-if="user.regions && user.regions.length" class="lg:col-span-2 text-[14px] text-[#555]">
              <strong>{{ t('regionUsers.labels.regions') }}:</strong>
              <span v-for="(reg, idx) in user.regions" :key="idx" class="ml-1 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 border border-gray-200">
                {{ reg }}
              </span>
            </div>
            <div v-else-if="!isCoordinator" class="lg:col-span-2 text-[14px] text-[#b91c1c]">
              <strong>{{ t('regionUsers.labels.regions') }}:</strong> Geen regio gekoppeld (check je postcode)
            </div>
            <div v-if="!isCoordinator && user.regionCoordinatorEmails && user.regionCoordinatorEmails.length" class="lg:col-span-2 text-[14px] text-[#555]">
              <strong>{{ t('regionUsers.labels.coordinatorEmail') }}:</strong>
              <span v-for="(email, idx) in user.regionCoordinatorEmails" :key="idx">
                <a :href="'mailto:'+email" class="ml-1 underline text-[#4a3f35]">{{ email }}</a><span v-if="idx < user.regionCoordinatorEmails.length - 1">,</span>
              </span>
            </div>

            <div v-if="isCoordinator && user.coupledRegions && user.coupledRegions.length" class="lg:col-span-2 text-[14px] text-[#555]">
              <strong>Gekoppelde regio's:</strong>
              <span v-for="(reg, idx) in user.coupledRegions" :key="idx" class="ml-1 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
                {{ reg }}
              </span>
            </div>
            <div v-else-if="isCoordinator" class="lg:col-span-2 text-[14px] text-[#b91c1c]">
              <strong>Gekoppelde regio's:</strong> Geen regio's gekoppeld als coördinator
            </div>
          </div>
          <div v-if="user.pendingEmail && user.pendingEmail.email" class="mt-4 text-[14px] bg-[#fff3cd] border border-[#ffe69c] text-[#664d03] p-3">
            Bevestiging in afwachting voor: <strong>{{ user.pendingEmail.email }}</strong>
          </div>
        </div>

        <!-- Logo (voor bedrijfsaccounts en scholen) -->
        <div v-if="isBedrijf || isSchool" class="bg-[#F6EBDC] p-5">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-10 h-10 bg-black text-white grid place-items-center font-extrabold">2</div>
            <h3 class="text-[20px] font-black italic uppercase m-0">{{ isBedrijf ? 'Logo' : 'Schoollogo' }}</h3>
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-[1060px] items-start">
            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div @click="zoomImage = (logoPreview || companyLogoUrl)" class="h-32 w-32 bg-white border border-[#d8d1c6] overflow-hidden flex items-center justify-center relative group cursor-zoom-in">
                <template v-if="logoPreview || companyLogoUrl">
                  <img :src="logoPreview || companyLogoUrl" :alt="isBedrijf ? 'Logo' : 'Schoollogo'" class="max-h-full max-w-full object-contain" loading="lazy" decoding="async" />
                  <div class="absolute inset-0 bg-black/40 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <svg class="w-6 h-6 text-white mb-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
                    <span class="text-white text-[10px] font-bold uppercase tracking-wider">{{ logoPreview ? 'Preview' : t('productManage.labels.image.zoom') }}</span>
                  </div>
                </template>
                <template v-else>
                  <span class="text-[12px] text-[#666] px-2 text-center">{{ t('materials.noImage') }}</span>
                </template>
              </div>
              <div class="flex-1 space-y-3">
                <div v-if="logoPreview" class="bg-[#d1e7dd] border border-[#badbcc] text-[#0f5132] px-3 py-1 text-[12px] inline-block font-semibold">
                  Preview van nieuw logo
                </div>
                <div class="flex flex-col gap-2">
                  <input type="file" accept="image/*" @change="onLogoChange" class="block text-[14px]" />
                  <div class="flex flex-wrap items-center gap-2">
                    <button type="button"
                            @click="uploadLogo"
                            :disabled="!logoFile || uploadingLogo"
                            class="h-10 bg-black text-white italic uppercase font-semibold px-4 disabled:opacity-60">
                      {{ uploadingLogo ? t('productManage.buttons.busy') : t('productManage.buttons.saveAndUpload') }}
                    </button>
                    <button v-if="logoPreview" type="button" @click="cancelLogoPreview" class="h-10 border border-black bg-white italic uppercase font-semibold px-4 hover:bg-black hover:text-white transition-colors">
                      {{ t('productManage.buttons.cancel') }}
                    </button>
                    <button v-if="companyLogoUrl && !logoPreview"
                            type="button"
                            @click="deleteLogo"
                            :disabled="deletingLogo"
                            class="h-10 border border-[#b91c1c] text-[#b91c1c] bg-white italic uppercase font-semibold px-4 hover:bg-[#b91c1c] hover:text-white transition-colors">
                      {{ deletingLogo ? t('productManage.buttons.busy') : t('productManage.buttons.delete') }}
                    </button>
                  </div>
                </div>
                <p class="text-[12px] text-[#666] m-0">{{ t('productManage.labels.image.recommended') }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Organisatie -->
        <div v-if="!isCoordinator" class="bg-[#F6EBDC] p-5">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-10 h-10 bg-black text-white grid place-items-center font-extrabold">{{ isBedrijf || isSchool ? 3 : 2 }}</div>
            <h3 class="text-[20px] font-black italic uppercase">{{ isBedrijf ? t('roles.company') : (isSchool ? t('roles.school') : 'Organisatie') }}</h3>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-[1060px]">
            <input v-model="orgName" type="text" :placeholder="(isBedrijf ? t('placeholders.orgNameCompany') : t('placeholders.orgNameSchool')) + ' *'" class="h-12 px-3 border bg-white border-[#d8d1c6]" />
            <input v-model="functionName" type="text" :placeholder="t('placeholders.functionName') + ' *'" class="h-12 px-3 border bg-white border-[#d8d1c6]" />
            <input v-model="street" type="text" :placeholder="t('placeholders.street') + ' *'" class="h-12 px-3 border bg-white border-[#d8d1c6]" />
            <input v-model="houseNr" type="text" :placeholder="t('placeholders.houseNr') + ' *'" class="h-12 px-3 border bg-white border-[#d8d1c6]" />
            <input v-model="postcode" type="text" :placeholder="t('placeholders.orgPostcode') + ' *'" class="h-12 px-3 border bg-white border-[#d8d1c6]" />
            <MmLocationAutocomplete
              v-model="cityLocationData"
              :placeholder="t('placeholders.city') + ' *'"
              :initialText="city"
              inputClass="h-12 px-3 border bg-white border-[#d8d1c6] w-full"
              :required="true"
              @select="onCitySelect"
              @clear="onCityClear"
            />
            <input v-model="website" type="url" :placeholder="t('placeholders.website')" class="h-12 px-3 border bg-white border-[#d8d1c6]" />
            <input v-model="phone" type="tel" :placeholder="t('placeholders.phone') + ' *'" class="h-12 px-3 border bg-white border-[#d8d1c6]" />
          </div>
        </div>

          <!-- Nieuwsbrief instellingen -->
        <div class="bg-[#F6EBDC] p-5">
          <div class="flex items-center gap-3 mb-4">
            <div class="w-10 h-10 bg-black text-white grid place-items-center font-extrabold">{{ isBedrijf ? 3 : (isSchool ? 4 : (isCoordinator ? 2 : 3)) }}</div>

            <h3 class="text-[20px] font-black italic uppercase">{{ t('newsletter.settingsTitle') }}</h3>
          </div>
          <p class="text-[14px] text-[#555] mb-4">{{ t('newsletter.settingsDesc') }}</p>
          <div class="max-w-[480px]">
            <h4 class="text-[16px] font-bold mb-2">{{ t('newsletter.frequencyLabel') }}</h4>
            <div class="relative">
              <select id="newsletterFrequency" v-model="newsletterFrequency"
                      class="h-12 px-3 pr-8 border border-[#d8d1c6] bg-white w-full appearance-none">
                <option :value="0">{{ t('newsletter.frequencyOff') }}</option>
                <option :value="7">{{ t('newsletter.frequencyWeekly') }}</option>
                <option :value="14">{{ t('newsletter.frequencyBiweekly') }}</option>
                <option :value="30">{{ t('newsletter.frequencyMonthly') }}</option>
              </select>
              <svg class="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none" fill="none"
                   stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
          </div>
        </div>

      <!-- Acties -->
        <div class="flex flex-wrap gap-3">
          <button type="button" @click="save" :disabled="saving || !formValid" class="h-12 bg-black text-white italic uppercase font-semibold px-6 disabled:opacity-60">
            {{ saving ? t('productManage.buttons.saving') : t('buttons.save') }}
          </button>
          <button type="button" @click="confirmDelete" class="h-12 bg-mm-red text-white italic uppercase font-semibold px-6">Account verwijderen</button>
        </div>

      </div>

      <div v-else class="text-[15px]">{{ t('messages.loading') }}</div>
    </div>
  </section>

  <!-- Zoom modal -->
  <MmModal v-model="zoomImage" :title="t('productManage.labels.image.zoomTitle')">
    <div class="flex items-center justify-center bg-white p-2 rounded overflow-hidden min-h-[300px]">
      <img v-if="zoomImage" :src="zoomImage" alt="Zoom" class="max-w-full max-h-[70vh] object-contain" />
    </div>
    <template #footer>
      <button type="button" class="mm-modal__button" @click="zoomImage = null">{{ t('buttons.close') }}</button>
    </template>
  </MmModal>
</template>

<script>
import MmFlashMessage from './MmFlashMessage.vue'
import MmModal from './MmModal.vue'
import MmLocationAutocomplete from './MmLocationAutocomplete.vue'
import WpApiClient from '../lib/wp-api.js'
import { t } from '../i18n'

export default {
  name: 'MmProfile',
  components: { MmFlashMessage, MmModal, MmLocationAutocomplete },
  props: {
    embedded: { type: Boolean, default: false },
    // Prestatie: gebruik reeds geladen user uit oudercomponent om dubbele fetch te voorkomen
    initialUser: { type: Object, default: null },
    t: { type: Function, default: t }
  },
  data(){
    return {
      loaded: false,
      user: null,
      api: null,
      // fields
      firstName: '', lastName: '', email: '', email2: '',
      orgName: '', functionName: '', street: '', houseNr: '', postcode: '', city: '', cityLocationData: null, website: '', phone: '',
      newsletterFrequency: 14,
      // company logo
      companyLogoUrl: '',
      companyLogoId: null,
      logoFile: null,
      logoPreview: '',
      uploadingLogo: false,
      deletingLogo: false,
      saving: false,
      message: '',
      error: '',
      // zoom
      zoomImage: null,
    }
  },
  computed: {
    isBedrijf(){ 
      const rt = ((this.user?.roleType)||'').toLowerCase()
      return rt === 'bedrijf'
    },
    isSchool(){ 
      const rt = ((this.user?.roleType)||'').toLowerCase()
      return rt === 'school'
    },
    isCoordinator(){ return !!(this.user?.isCoordinator) || ((this.user?.roleType)||'').toLowerCase()==='coordinator' },
    formValid(){
      // Verplichte basisvelden
      if (!this.firstName || !this.lastName || !this.email || !this.email2) return false
      
      // Email validatie
      if (!this.isValidEmail(this.email) || !this.isValidEmail(this.email2)) return false
      if (this.email !== this.email2) return false

      // Voor coördinatoren zijn organisatievelden niet verplicht/aanwezig
      if (this.isCoordinator) return true

      // Organisatievelden
      if (!this.orgName || !this.functionName || !this.street || !this.houseNr || !this.postcode || (!this.city && !this.cityLocationData) || !this.phone) return false

      return true
    }
  },
  watch: {
    initialUser: {
      immediate: true,
      handler(u) {
        if (u) {
          this.setFromUser(u)
          this.loaded = true
          if (!this.api) this.api = new WpApiClient()
        } else if (!this.loaded) {
          this.load()
        }
      }
    }
  },
  methods: {
    t,
    setFromUser(u){
      if (!u) return
      this.user = u
      this.firstName = u.firstName || ''
      this.lastName = u.lastName || ''
      this.email = u.email || ''
      this.email2 = u.email || ''
      this.orgName = u.orgName || ''
      this.functionName = u.functionName || ''
      this.street = u.street || ''
      this.houseNr = u.houseNr || ''
      this.postcode = u.postcode || ''
      this.city = u.city || ''
      this.website = u.website || ''
      this.phone = u.phone || ''
      this.companyLogoUrl = u.companyLogoUrl || ''
      this.companyLogoId = u.companyLogoId || null
      this.newsletterFrequency = (u.newsletterFrequency !== undefined && u.newsletterFrequency !== null) ? parseInt(u.newsletterFrequency) : 14
    },
    isValidEmail(v){
      const s = String(v||'').trim();
      if (!s) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)
    },
    async load(){
      if (!this.api) this.api = new WpApiClient()
      try{
        let res = await this.api.getCurrentUser({ nonce: (window.materiaalAjax && materiaalAjax.nonce) ? materiaalAjax.nonce : undefined })
        
        // Automatische retry bij nonce error
        if (res && !res.ok && (res.error === 'invalid_nonce' || (res.error && res.error.includes('nonce')))) {
          const newNonce = await this.api.refreshNonce(false);
          if (newNonce) {
            res = await this.api.getCurrentUser({ nonce: newNonce });
          }
        }

        if (res && res.ok && res.user) {
          this.setFromUser(res.user)
        }
      } catch(e){ this.error = e?.message || 'Laden mislukt'; }
      this.loaded = true
    },
    onLogoChange(e){
      const file = (e?.target?.files || [])[0]
      if (!file) {
        this.logoFile = null;
        if (this.logoPreview) { try { URL.revokeObjectURL(this.logoPreview) } catch(_){} }
        this.logoPreview = '';
        return
      }
      // basic validation
      const allowed = ['image/jpeg','image/png','image/gif','image/webp','image/svg+xml']
      if (!allowed.includes(file.type)) {
        this.error = 'Ongeldig bestandstype. Kies een afbeelding (jpg, png, gif, webp, svg).'
        this.logoFile = null
        this.logoPreview = ''
        return
      }
      if (file.size > 5*1024*1024) {
        this.error = 'Bestand is te groot (max 5MB).'
        this.logoFile = null
        this.logoPreview = ''
        return
      }
      this.error = ''
      this.logoFile = file
      try {
        if (this.logoPreview) { try { URL.revokeObjectURL(this.logoPreview) } catch(_){} }
        this.logoPreview = URL.createObjectURL(file)
      } catch(_) { this.logoPreview = '' }
    },
    onCitySelect(item) {
      this.cityLocationData = item
      this.city = item?.display_name || item?.place_name || ''
    },
    onCityClear() {
      this.cityLocationData = null
      this.city = ''
    },
    cancelLogoPreview(){
      if (this.logoPreview) { try { URL.revokeObjectURL(this.logoPreview) } catch(_){} }
      this.logoPreview = ''
      this.logoFile = null
      // Reset input element
      const input = this.$el.querySelector('input[type="file"]')
      if (input) input.value = ''
    },
    async uploadLogo(){
      if (!this.logoFile) return
      this.uploadingLogo = true
      try{
        const res = await this.api.uploadCompanyLogo(this.logoFile, { nonce: (window.materiaalAjax && materiaalAjax.nonce) ? materiaalAjax.nonce : undefined })
        if (res && res.ok) {
          this.companyLogoUrl = res.url || this.companyLogoUrl
          this.companyLogoId = res.id || this.companyLogoId
          this.cancelLogoPreview()
          this.message = 'Logo geüpload.'
        } else {
          this.error = (res && res.error) || 'Upload mislukt'
        }
      } catch(e){ this.error = e?.message || 'Upload mislukt' }
      this.uploadingLogo = false
    },
    async deleteLogo(){
      const confirmMsg = this.isBedrijf ? 'Weet je zeker dat je het logo wilt verwijderen?' : 'Weet je zeker dat je het schoollogo wilt verwijderen?';
      if (!window.confirm(confirmMsg)) return
      this.deletingLogo = true
      this.error = ''
      this.message = ''
      try {
        const res = await this.api.deleteCompanyLogo({ nonce: (window.materiaalAjax && materiaalAjax.nonce) ? materiaalAjax.nonce : undefined })
        if (res && res.ok) {
          this.companyLogoUrl = ''
          this.companyLogoId = null
          this.message = 'Logo verwijderd.'
        } else {
          this.error = res?.error || 'Verwijderen mislukt'
        }
      } catch (e) { this.error = e?.message || 'Verwijderen mislukt' }
      this.deletingLogo = false
    },
    async save(){
      this.saving = true; this.message=''; this.error='';
      try{
        const payload = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          email2: this.email2,
          newsletterFrequency: this.newsletterFrequency,
          nonce: (window.materiaalAjax && materiaalAjax.nonce) ? materiaalAjax.nonce : undefined,
        }
        // Organisatievelden alleen meesturen voor niet‑coördinatoren
        if (!this.isCoordinator) {
          Object.assign(payload, {
            orgName: this.orgName,
            functionName: this.functionName,
            street: this.street,
            houseNr: this.houseNr,
            postcode: this.postcode,
            city: this.cityLocationData?.display_name || this.cityLocationData?.place_name || this.city,
            city_location_data: this.cityLocationData ? JSON.stringify(this.cityLocationData) : undefined,
            website: this.website,
            phone: this.phone,
          })
        }
        const res = await this.api.updateProfile(payload)
        if (res && res.ok) {
          this.message = res.message || 'Gegevens opgeslagen.'
          await this.load()
        } else {
          this.error = (res && res.error) || 'Opslaan mislukt'
        }
      } catch(e){ this.error = e?.message || 'Opslaan mislukt' }
      this.saving = false
    },
    confirmDelete(){
      if (!window.confirm('Weet je zeker dat je je account wilt verwijderen? Dit kan niet ongedaan worden gemaakt.')) return;
      this.deleteAccount()
    },
    async deleteAccount(){
      try{
        const res = await this.api.deleteAccount({ nonce: (window.materiaalAjax && materiaalAjax.nonce) ? materiaalAjax.nonce : undefined })
        if (res && res.ok) {
          // Redirect to homepage or login
          window.location.href = (window.materiaalAjax && materiaalAjax.loginUrl) ? materiaalAjax.loginUrl : '/wp-login.php'
        } else {
          this.error = (res && res.error) || 'Verwijderen mislukt'
        }
      } catch(e){ this.error = e?.message || 'Verwijderen mislukt' }
    }
  },
  mounted(){
    // Toon succesmelding na e‑mailbevestiging via query param
    try{
      const params = new URLSearchParams(window.location.search || '');
      if (params.get('email_confirmed') === '1') {
        this.message = 'Je e‑mailadres is bevestigd en bijgewerkt.'
        // Verwijder de query param uit de URL zodat de melding niet blijft hangen bij refresh
        const url = new URL(window.location.href);
        url.searchParams.delete('email_confirmed');
        window.history.replaceState({}, document.title, url.toString());
      }
      // Toon foutmelding (bijv. ongeldige/verlopen token) in dezelfde layout
      const emailErr = params.get('email_error');
      if (emailErr) {
        // URLSearchParams decodeert al; zet direct als foutmelding
        this.error = emailErr;
        const url = new URL(window.location.href);
        url.searchParams.delete('email_error');
        window.history.replaceState({}, document.title, url.toString());
      }
    } catch(e){}
  }
}
</script>

<style scoped>
</style>
